/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B020050 売上チェックリスト
 */
import {
  B000120EigyoNmr,
  B000130BumonNmFrom,
  B000130BumonNmTo,
  B000140ShainNmFrom,
  B000140ShainNmTo,
  B000150TokuiNmFrom,
  B000150TokuiNmTo,
  B020050GetExcel,
  B020050Request,
  B020050TogetsuYm,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { B020050ShokaKbn, B020050Sort, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B000120, B000130, B000140, B000150, B000202 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, download } from "services";
import { shokaKbn } from "services/codes";
import { authState, focusState, navigateTypeState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  uriYmdFrom: string;
  uriYmdTo: string;
  hasoYmdFrom: string;
  hasoYmdTo: string;
  eigyoCd: string;
  eigyoNmr: string;
  bumonCdFrom: string;
  bumonNmFrom: string;
  bumonCdTo: string;
  bumonNmTo: string;
  shainCdFrom: string;
  shainNmFrom: string;
  shainCdTo: string;
  shainNmTo: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiNmFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  tokuiNmTo: string;
  shokaKbn: SCode;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  sort1: SCode;
  sort2: SCode;
  sort3: SCode;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  uriYmdFrom: "",
  uriYmdTo: date(),
  hasoYmdFrom: "",
  hasoYmdTo: date(),
  eigyoCd: undefined,
  bumonCdFrom: "",
  bumonNmFrom: "",
  bumonCdTo: "",
  bumonNmTo: "",
  shainCdFrom: "",
  shainNmFrom: "",
  shainCdTo: "",
  shainNmTo: "",
  uridenpyoNoFrom: "",
  uridenpyoNoTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiNmFrom: "",
  tokuiCdTo: "",
  tokuishitenCdTo: "",
  tokuiNmTo: "",
  shokaKbn: getSCode(B020050ShokaKbn, "0")!,
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  sort1: getSCode(B020050Sort, "2")!,
  sort2: getSCode(B020050Sort, "3")!,
  sort3: getSCode(B020050Sort, "0")!,
};

const focusId = "B020050";

export const B020050 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  //ログイン者情報取得
  const auth = useRecoilValue(authState);
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();
  const menuNavigate = useRecoilValue(navigateTypeState);

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "menu") {
      // 通常の初期表示時の処理を記載する。

      // 初期表示
      (async () => {
        await methods.setValue("eigyoCd", auth?.eigyoCd!);

        await B000120EigyoNmr(methods, navigate, setMsg);
      })();

      // 初回フォーカス先
      // システムマスタの当月の初日
      (async () => {
        await B020050TogetsuYm(methods, navigate, setMsg);
        focus(1);
      })();
      return;
    }
  }, []);

  //Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    // Excel出力フォームのデータを取得する。
    const fields = methods.getValues();

    // 消化区分
    let paramShokaKbn;
    if (fields.shokaKbn?.value! === "0") {
      paramShokaKbn = undefined;
    } else if (fields.shokaKbn?.value! === "1") {
      paramShokaKbn = shokaKbn.normal;
    } else if (fields.shokaKbn?.value! === "2") {
      paramShokaKbn = shokaKbn.shoka;
    }

    let order1: string = "";
    // 出力順の値に応じたソート処理
    if (fields.sort1?.value === "0") {
      order1 = "tokuiCd";
    } else if (fields.sort1?.value === "1") {
      order1 = "shainCd";
    } else if (fields.sort1?.value === "2") {
      order1 = "uriYmd";
    } else if (fields.sort1?.value === "3") {
      order1 = "uridenpyoNo";
    }

    let order2: string = "";
    if (fields.sort2?.value === "0") {
      order2 = "tokuiCd";
    } else if (fields.sort2?.value === "1") {
      order2 = "shainCd";
    } else if (fields.sort2?.value === "2") {
      order2 = "uriYmd";
    } else if (fields.sort2?.value === "3") {
      order2 = "uridenpyoNo";
    }

    let order3: string = "";
    if (fields.sort3?.value === "0") {
      order3 = "tokuiCd";
    } else if (fields.sort3?.value === "1") {
      order3 = "shainCd";
    } else if (fields.sort3?.value === "2") {
      order3 = "uriYmd";
    } else if (fields.sort3?.value === "3") {
      order3 = "uridenpyoNo";
    }

    // Excel出力パラメータを作成する。
    const param: B020050Request = {
      uriYmdFrom: fields.uriYmdFrom,
      uriYmdTo: fields.uriYmdTo,
      hasoYmdFrom: fields.hasoYmdFrom,
      hasoYmdTo: fields.hasoYmdTo,
      eigyoCd: fields.eigyoCd!,
      bumonCdFrom: fields.bumonCdFrom,
      bumonCdTo: fields.bumonCdTo,
      shainCdFrom: fields.shainCdFrom,
      shainCdTo: fields.shainCdTo,
      uridenpyoNoFrom: fields.uridenpyoNoFrom,
      uridenpyoNoTo: fields.uridenpyoNoTo,
      juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
      juchudenpyoNoTo: fields.juchudenpyoNoTo,
      tokuiCdFrom: fields.tokuiCdFrom,
      tokuishitenCdFrom: fields.tokuishitenCdFrom,
      tokuiCdTo: fields.tokuiCdTo,
      tokuishitenCdTo: fields.tokuishitenCdTo,
      shokaKbn: paramShokaKbn,
      sort1: order1,
      sort2: order2,
      sort3: order3,
      shodaibun: fields.shodaibun,
      shochubun: fields.shochubun,
      shoshobun: fields.shoshobun,
    };
    B020050GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B020050_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  //商品中分類が入力されているかどうか
  const existShochubun: boolean = methods.watch("shochubun") !== "";
  //商品小分類が入力されているかどうか
  const existShoshobun: boolean = methods.watch("shoshobun") !== "";

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="売上チェックリスト"
        gridTemplateColumns="6rem 3rem 3rem 5rem 1rem 10rem 1rem 6rem 5rem 11rem 6rem"
      >
        <SLabel>伝票日付</SLabel>
        <SDateField name="uriYmdFrom" {...register(1)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="uriYmdTo" {...register(2)} />
        <SLabel gridColumn="1">発送日</SLabel>
        <SDateField name="hasoYmdFrom" {...register(3)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="hasoYmdTo" {...register(4)} />
        <SLabel required gridColumn={1}>
          営業所
        </SLabel>
        <STextField
          label="営業所コード"
          name="eigyoCd"
          required
          {...register(5)}
          size={6}
          gridColumn="span 3"
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCd", data.eigyoCd);
            methods.setValue("eigyoNmr", data.eigyoNmr);
          }}
          onBlur={() => B000120EigyoNmr(methods, navigate, setMsg)}
        />
        <STextField name="eigyoNmr" gridColumn="span 2" disabled />

        <SLabel gridColumn="1">売上担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          {...register(6)}
          onBlur={() => B000130BumonNmFrom(methods, navigate, setMsg)}
          gridColumn="span 3"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
            methods.setValue("bumonNmFrom", data.bumonNm);
          }}
        />
        <STextField name="bumonNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          {...register(7)}
          onBlur={() => B000130BumonNmTo(methods, navigate, setMsg)}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
            methods.setValue("bumonNmTo", data.bumonNm);
          }}
        />
        <STextField name="bumonNmTo" size={40} disabled />
        <SLabel gridColumn="1">売上担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          {...register(8)}
          onBlur={() => B000140ShainNmFrom(methods, navigate, setMsg)}
          gridColumn="span 3"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
            methods.setValue("shainNmFrom", data.shainNm);
          }}
        />
        <STextField name="shainNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          {...register(9)}
          onBlur={() => B000140ShainNmTo(methods, navigate, setMsg)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
            methods.setValue("shainNmTo", data.shainNm);
          }}
        />
        <STextField name="shainNmTo" size={40} disabled />
        <SLabel gridColumn="1">売上No</SLabel>
        <SNumberField
          name="uridenpyoNoFrom"
          code
          size={10}
          {...register(10)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SNumberField name="uridenpyoNoTo" code size={10} {...register(11)} />
        <SLabel gridColumn="1">受注No</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(12)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SNumberField name="juchudenpyoNoTo" code size={10} {...register(13)} />
        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCdFrom"
          code
          size={6}
          {...register(14)}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          gridColumn="span 2"
        />
        <SNumberField
          name="tokuishitenCdFrom"
          code
          size={4}
          {...register(15)}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdFrom", data.tokuiCd);
            methods.setValue("tokuishitenCdFrom", data.tokuishitenCd);
            methods.setValue("tokuiNmFrom", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="tokuiCdTo"
          code
          size={6}
          {...register(16)}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCdTo"
          code
          size={4}
          {...register(17)}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdTo", data.tokuiCd);
            methods.setValue("tokuishitenCdTo", data.tokuishitenCd);
            methods.setValue("tokuiNmTo", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmTo" size={40} disabled />
        <SLabel gridColumn={1}>消化区分</SLabel>
        <SCodeSelect
          name="shokaKbn"
          options={B020050ShokaKbn}
          {...register(18)}
          gridColumn="span 3"
        />
        <SLabel gridColumn={1}>出力順</SLabel>
        <SCodeSelect
          name="sort1"
          options={B020050Sort}
          {...register(19)}
          gridColumn="span 3"
        />
        <SCodeSelect
          name="sort2"
          options={B020050Sort}
          {...register(20)}
          gridColumn="span 2"
        />
        <SCodeSelect
          name="sort3"
          options={B020050Sort}
          {...register(21)}
          gridColumn="span 3"
        />
        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          name="shodaibun"
          label="商品分類(大)"
          code
          size={3}
          required={existShochubun}
          {...register(22)}
        />
        <SNumberField
          name="shochubun"
          label="商品分類(中)"
          code
          size={3}
          required={existShoshobun}
          {...register(23)}
        />
        <SNumberField
          name="shoshobun"
          label="商品分類(小)"
          code
          size={3}
          {...register(24)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
        />
        <SFileButton
          label={labels.buttons.excel}
          gridRow={12}
          gridColumn={11}
          {...register(25)}
          onClick={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
